import React, { useState } from "react";
import CompetitionTable from "./CompetitionTable";
import CreateCompetitionModal from "./CreateCompetitionModal";
import UpdateCompetitionModal from "./UpdateCompetitionModal";

function CompetitionsPage() {
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [showUpdateModal, setShowUpdateModal] = useState(false);
  const [selectedCompetition, setSelectedCompetition] = useState(null);

  // Dummy data for competitions
  const competitions = [
    { id: 1, name: "Competition 1", date: "2023-06-01" },
    { id: 2, name: "Competition 2", date: "2023-07-01" },
    { id: 3, name: "Competition 3", date: "2023-08-01" },
  ];

  // Function to handle click on create competition button
  const handleCreateCompetition = () => {
    setShowCreateModal(true);
  };

  // Function to handle click on edit competition button
  const handleEditCompetition = (competition) => {
    setSelectedCompetition(competition);
    setShowUpdateModal(true);
  };

  // Function to handle close of create competition modal
  const handleCloseCreateModal = () => {
    setShowCreateModal(false);
  };

  // Function to handle close of update competition modal
  const handleCloseUpdateModal = () => {
    setSelectedCompetition(null);
    setShowUpdateModal(false);
  };

  return (
    <div>
      <h1>Competitions</h1>
      <button onClick={handleCreateCompetition}>Create Competition</button>
      <CompetitionTable
        competitions={competitions}
        onEditCompetition={handleEditCompetition}
      />
      {showCreateModal && (
        <CreateCompetitionModal onClose={handleCloseCreateModal} />
      )}
      {showUpdateModal && (
        <UpdateCompetitionModal
          competition={selectedCompetition}
          onClose={handleCloseUpdateModal}
        />
      )}
    </div>
  );
}

export default CompetitionsPage;